<template>
  <CChartLine :datasets="defaultDatasets" :labels="label" />
</template>

<script>
import { CChartLine } from "@coreui/vue-chartjs";
import DateFo from "../../services/DateFormat";
export default {
  name: "Precipitation",
  props: ["lab"],
  data() {
    return {
      label: [],
      check: [],
    };
  },
  components: { CChartLine },
  computed: {
    defaultDatasets() {
      return [
        {
          label: "Precipitation  / mm",
          backgroundColor: "#b9a26c",
          data: this.check,
        },
      ];
    },
  },
  created() {
    for (var i = 0; i < 10; i++) {
      this.label.push(DateFo.messageDate(this.lab.hourly.data[i].time));
      this.check.push(this.lab.hourly.data[i].precipProbability);
    }
  },
};
</script>
